<template>
  <div class="proxy-messages-page">
    <MessagesSearchForm />

    <MessagesTable :detailed="true" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import MessagesTable from '@/views/Components/Messages/MessagesTable.vue'
import MessagesSearchForm from '@/views/Staff/Proxy/Messages/SearchForm.vue'

export default defineComponent({
  name: 'ProxyMessagesPage',
  components: { MessagesSearchForm, MessagesTable },
})
</script>
